/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Avatar,
  Button,
  Dropdown,
  Image,
  TableColumnsType,
  Tag,
  Tooltip,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { PopUp } from "../../atoms/PopUp";
import EmptyCard from "../../atoms/EmptyCard";
import { CrossIcon, DeleteIcon, NeedHelp } from "../../atoms/CustomIcons";
import ConfirmDelete from "../../atoms/ConfirmDelete";
import { MoreOutlined } from "@ant-design/icons";
import DashboardTemplate from "../../templates/Dashboard";
import Header from "../../atoms/Header";
import {
  getCompanyInitials,
  getValueBeforeUnderscore,
  PAGE_LIMIT,
} from "../../config/utils";
import TaskModal from "./Components/TaskModal";
import Filters from "./Components/Filters";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../config/hooks";
import { getContractListing, removeContractListData } from "./ducks/actions";
import dayjs from "dayjs";
import TableUi from "../../atoms/Table";
import { contractUnwin } from "./ducks/services";
import { ErrorMessage } from "../../atoms/Toasts/ErrorMessage";
import { AxiosError } from "axios";
import { SuccessMessage } from "../../atoms/Toasts/SuccessMessage";
import TerminatePopUp from "./Components/TerminatePopUp";

export default function Contracts() {
  const location = window.location.pathname;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(PAGE_LIMIT);
  const [tableRecord, setTableRecord] = useState<any | null>(null);
  // const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isTerminateModalOpen, setIsTerminateModalOpen] = useState(false);
  const [isUnWinModalOpen, setIsUnWinModalOpen] = useState(false);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [archivePopUp, setArchivePopUp] = useState(false);
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [archived, isArchived] = useState(false);
  const contractListData = useAppSelector(
    (state) => state?.contract?.contractListData
  );

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string;
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const items = [
    // {
    //   key: "1",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         navigate(
    //           `/edit-contracts/${tableRecord?.id}/${tableRecord?.proposal_id}/${tableRecord?.deal_id}/${companyId}`
    //         );
    //       }}
    //       icon={<Image src="/images/contracts/edit.svg" preview={false} />}
    //     >
    //       Edit details
    //     </Button>
    //   ),
    // },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            navigate(
              `/create-upsale/${tableRecord?.id}/${tableRecord?.proposal_id}/${tableRecord?.deal_id}/${companyId}`
            );
          }}
          icon={<Image src="/images/contracts/upsale.svg" preview={false} />}
        >
          Upsell
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            navigate(
              `/change-order/${tableRecord?.id}/${tableRecord?.proposal_id}/${tableRecord?.deal_id}/${companyId}`
            );
          }}
          icon={
            <Image src="/images/contracts/change-order.svg" preview={false} />
          }
        >
          Change order
        </Button>
      ),
    },
    {
      key: "4",
      disable: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setIsUnWinModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
          disabled={true}
          icon={<Image src="/images/contracts/unwin.svg" preview={false} />}
        >
          Unwin
        </Button>
      ),
    },
    {
      key: "5",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setIsTerminateModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
          disabled={true}
          icon={<Image src="/images/contracts/terminate.svg" preview={false} />}
        >
          Terminate
        </Button>
      ),
    },
    {
      key: "6",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          disabled={true}
          icon={<Image src="/images/contracts/renew.svg" preview={false} />}
        >
          Renew
        </Button>
      ),
    },
    // {
    //   key: "7",
    //   label: (
    //     <Button
    //       type="text"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         setIsDeleteModalOpen(true);
    //         if (dropdownRef.current) {
    //           dropdownRef?.current?.click();
    //         }
    //       }}
    //       className="delete-hover"
    //       icon={<DeleteIcon />}
    //     >
    //       Delete
    //     </Button>
    //   ),
    // },
  ];

  const statusClassMap: Record<string, string> = {
    active: "accepted_tag",
    "Closure pending": "approval_pending_tag",
    "Termination pending": "sent_tag",
  };

  const columns: TableColumnsType = [
    {
      title: "Contract name",
      dataIndex: "name",
      width: 320,
      render: (text) => (
        <Tooltip title={text ? text : "-"}>
          <span className="table-col-ellipsis" style={{ width: "310px" }}>
            {text ? text : "-"}
          </span>
        </Tooltip>
      ),
      fixed: "left",
      sorter: (a, b) =>
        a.name?.localeCompare(b.name) || a.name?.length - b.name?.length,
    },
    {
      title: "Property name",
      dataIndex: "property_name",
      width: 230,
      render: (text) => (
        <Tooltip title={text ? text : "-"}>
          <span className="table-col-ellipsis" style={{ width: "220px" }}>
            {text ? text : "-"}
          </span>
        </Tooltip>
      ),
      sorter: (a, b) =>
        a.property_name?.localeCompare(b.property_name) ||
        a.property_name?.length - b.property_name?.length,
    },
    {
      title: "Service line",
      dataIndex: "service_lines",
      width: 273,
      sorter: (a, b) =>
        a.service_line?.localeCompare(b.service_line) ||
        a.service_line?.length - b.service_line?.length,
      render: (text) => {
        if (!Array.isArray(text) || text.length === 0) return "-";

        return (
          <div style={{ display: "flex", gap: "4px" }}>
            {text.slice(0, 1).map((item, i) => (
              <Tag
                key={i}
                className={`defaultTag ${
                  item?.color
                    ? getValueBeforeUnderscore(item?.color)
                    : "default_tag"
                }`}
                style={{
                  textTransform: "capitalize",
                  border: 0,
                  marginRight: 4,
                }}
              >
                {item?.name}
              </Tag>
            ))}

            {text.length > 1 && (
              <Tooltip
                title={text
                  .slice(1)
                  .map((e) => e?.name)
                  .join(", ")}
              >
                <Tag
                  style={{
                    background: "#EFF2F3",
                    color: "#151718",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  +{text.length - 1}
                </Tag>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 170,
      render: (text) => {
        const cls = statusClassMap[text] || "default_tag";
        return text ? (
          <Tag className={cls} style={{ textTransform: "capitalize" }}>
            {text}
          </Tag>
        ) : (
          "-"
        );
      },
      sorter: (a, b) =>
        a.status?.localeCompare(b.status) ||
        a.status?.length - b.status?.length,
    },
    {
      title: "Start date",
      dataIndex: "start_date",
      width: 130,
      render: (text) => (text ? dayjs(text).format("ll") : "-"),
      sorter: (a, b) =>
        a.start_date?.localeCompare(b.start_date) ||
        a.start_date?.length - b.start_date?.length,
    },
    {
      title: "End date",
      dataIndex: "end_date",
      width: 130,
      render: (text) => (text ? dayjs(text).format("ll") : "-"),
      sorter: (a, b) =>
        a.end_date?.localeCompare(b.end_date) ||
        a.end_date?.length - b.end_date?.length,
    },
    {
      title: "Renewable",
      dataIndex: "is_renewable",
      width: 140,
      render: (text) => (
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {text ? "Yes" : "No"}
        </span>
      ),
      sorter: (a, b) =>
        a.is_renewable?.localeCompare(b.is_renewable) ||
        a.is_renewable?.length - b.is_renewable?.length,
    },
    {
      title: "Property category",
      dataIndex: "property_category",
      width: 163,
      render: (text) =>
        text?.length > 0
          ? text?.map((e: string) => <Tag className="default_tag">{e}</Tag>)
          : "-",
      sorter: (a, b) =>
        a.property_category?.localeCompare(b.property_category) ||
        a.property_category?.length - b.property_category?.length,
    },
    {
      title: "Production manager",
      dataIndex: "production_managers",
      width: 270,
      sorter: (a, b) =>
        a.production_managers?.localeCompare(b.production_managers) ||
        a.production_managers?.length - b.production_managers?.length,
      render: (text: any[]) =>
        text?.length > 0 ? (
          <div className="text_with_avatar">
            {text
              ?.slice(0, 1)
              ?.map((e: { image: string; name: string }, i: number) => {
                return (
                  <span
                    key={i}
                    style={{
                      marginRight: "0px",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    {e?.image ? (
                      <div className="participant_avatar">
                        <Avatar src={e?.image} />
                      </div>
                    ) : (
                      <div className="participant_avatar">
                        <Avatar> {getCompanyInitials(e?.name)}</Avatar>
                      </div>
                    )}
                    {e?.name && (
                      <span style={{ textTransform: "capitalize" }}>
                        {e?.name}
                      </span>
                    )}
                  </span>
                );
              })}

            {text?.length > 1 && (
              <Tooltip
                title={text
                  ?.slice(1)
                  ?.map((e: { name: string }) => {
                    return e.name;
                  })
                  ?.join(", ")}
              >
                <Tag
                  style={{
                    background: "#EFF2F3",
                    color: "#151718",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  +{text?.length - 1}
                </Tag>
              </Tooltip>
            )}
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: "Account manager",
      dataIndex: "account_manager_name",
      width: 180,
      sorter: (a, b) =>
        a.account_manager_name?.localeCompare(b.account_manager_name) ||
        a.account_manager_name?.length - b.account_manager_name?.length,
      render: (text, record) =>
        record?.account_manager_name ? (
          <div className="text_with_avatar">
            {record?.account_manager_image_url ? (
              <div className="participant_avatar">
                <Avatar src={record?.account_manager_image_url} />
              </div>
            ) : (
              <div className="participant_avatar">
                <Avatar>{getCompanyInitials(text)}</Avatar>
              </div>
            )}
            <span style={{ textTransform: "capitalize" }}>
              {text ? text : "-"}
            </span>
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: "Crew",
      dataIndex: "crews",
      width: 280,
      render: (text) => {
        if (!text) return "-";
        return (
          <>
            {text.map((item: string) => {
              const trimmed = item.trim();
              return (
                <Tag
                  key={trimmed}
                  className="ant-tag default_tag"
                  style={{
                    marginRight: 4,
                    border: "1px solid #eff2f3 !important",
                  }}
                >
                  {trimmed}
                </Tag>
              );
            })}
          </>
        );
      },
      sorter: (a, b) =>
        a.crew?.localeCompare(b.crew) || a.crew?.length - b.crew?.length,
    },
    {
      title: "Pricing model",
      dataIndex: "pricing_model",
      width: 140,
      render: (text) => (
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {text
            ? text
                ?.replace("_", " ")
                .replace(/^\w/, (c: string): string => c.toUpperCase())
            : "-"}
        </span>
      ),
      sorter: (a, b) =>
        a.pricing_model?.localeCompare(b.pricing_model) ||
        a.pricing_model?.length - b.pricing_model?.length,
    },
    {
      title: "Billing",
      dataIndex: "billing",
      width: 220,
      render: (text) => (
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {text
            ? text
                ?.replace(/_/g, " ")
                .replace(/^\w/, (c: string): string => c.toUpperCase())
            : "-"}
        </span>
      ),
      sorter: (a, b) =>
        a.billing?.localeCompare(b.billing) ||
        a.billing?.length - b.billing?.length,
    },
    {
      title: "Net terms",
      dataIndex: "net_terms",
      width: 180,
      render: (text) => (
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {text
            ? text
                ?.replace(/_/g, " ")
                .replace(/^\w/, (c: string): string => c.toUpperCase())
            : "-"}
        </span>
      ),
      sorter: (a, b) =>
        a.net_terms?.localeCompare(b.net_terms) ||
        a.net_terms?.length - b.net_terms?.length,
    },
    {
      title: "Original contract revenue, $",
      dataIndex: "original_revenue",
      width: 230,
      render: (text) => <span>{text ? text : "-"}</span>,
      sorter: (a, b) =>
        a.original_revenue?.localeCompare(b.original_revenue) ||
        a.original_revenue?.length - b.original_revenue?.length,
      align: "right",
      className: "right-aligned-sorter",
    },
    {
      title: "Projected revenue, $",
      dataIndex: "projected_revenue",
      width: 230,
      render: (text) => <span>{text ? text : "-"}</span>,
      sorter: (a, b) =>
        a.projected_revenue?.localeCompare(b.projected_revenue) ||
        a.projected_revenue?.length - b.projected_revenue?.length,
      align: "right",
      className: "right-aligned-sorter",
    },
    {
      title: "Earned revenue to date, $",
      dataIndex: "earned_revenue",
      width: 230,
      render: (text) => <span>{text ? text : "-"}</span>,
      sorter: (a, b) =>
        a.earned_revenue?.localeCompare(b.earned_revenue) ||
        a.earned_revenue?.length - b.earned_revenue?.length,
      align: "right",
      className: "right-aligned-sorter",
    },
    {
      title: "Original GM, %",
      dataIndex: "original_gross_profit",
      width: 180,
      render: (text) => <span>{text ? text : "-"}</span>,
      sorter: (a, b) =>
        a.original_gross_profit?.localeCompare(b.original_gross_profit) ||
        a.original_gross_profit?.length - b.original_gross_profit?.length,
      align: "right",
      className: "right-aligned-sorter",
    },
    {
      title: "Original GM, $",
      dataIndex: "original_gross_margin",
      width: 180,
      render: (text) => <span>{text ? text : "-"}</span>,
      sorter: (a, b) =>
        a.original_gross_margin?.localeCompare(b.original_gross_margin) ||
        a.original_gross_margin?.length - b.original_gross_margin?.length,
      align: "right",
      className: "right-aligned-sorter",
    },
    {
      title: "Projected GM, %",
      dataIndex: "projected_gross_profit",
      width: 180,
      render: (text) => <span>{text ? text : "-"}</span>,
      sorter: (a, b) =>
        a.projected_gross_profit?.localeCompare(b.projected_gross_profit) ||
        a.projected_gross_profit?.length - b.projected_gross_profit?.length,
      align: "right",
      className: "right-aligned-sorter",
    },
    {
      title: "Projected GM, $",
      dataIndex: "projected_gross_margin",
      width: 180,
      render: (text) => <span>{text ? text : "-"}</span>,
      sorter: (a, b) =>
        a.projected_gross_margin?.localeCompare(b.projected_gross_margin) ||
        a.projected_gross_margin?.length - b.projected_gross_margin?.length,
      align: "right",
      className: "right-aligned-sorter",
    },
    {
      title: "To date GM, %",
      dataIndex: "to_date_gross_profit",
      width: 180,
      render: (text) => <span>{text ? text : "-"}</span>,
      sorter: (a, b) =>
        a.to_date_gross_profit?.localeCompare(b.to_date_gross_profit) ||
        a.to_date_gross_profit?.length - b.to_date_gross_profit?.length,
      align: "right",
      className: "right-aligned-sorter",
    },
    {
      title: "To date GM, $",
      dataIndex: "to_date_gross_margin",
      width: 180,
      render: (text) => <span>{text ? text : "-"}</span>,
      sorter: (a, b) =>
        a.to_date_gross_margin?.localeCompare(b.to_date_gross_margin) ||
        a.to_date_gross_margin?.length - b.to_date_gross_margin?.length,
      align: "right",
      className: "right-aligned-sorter",
    },
    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{ items }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              e.stopPropagation();
              setTableRecord(record);
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      ),
    },
  ];

  const fetchContractList = () => {
    const payload = {
      status: filters?.status ?? ["active"],
      offset: pagination > 1 ? limit * (pagination - 1) : pagination - 1,
      limit: limit,
      company_id: companyId,
      type: filters?.type ?? undefined,
      search_text: filters?.search_text ?? undefined,
    };
    dispatch(getContractListing(payload));
  };

  // const deleteFunction = () => {
  //   setLoading(true);
  //   const payload = {
  //     deal_id: tableRecord?.deal_id,
  //   };
  //   deleteContract(tableRecord?.id, payload)
  //     .then(() => {
  //       setLoading(false);
  //       setIsDeleteModalOpen(false);
  //       fetchContractList();
  //       SuccessMessage("Contract deleted");
  //     })
  //     .catch((e: unknown) => {
  //       if (e instanceof AxiosError) {
  //         setLoading(false);
  //         ErrorMessage(
  //           e?.response?.data?.error?.message ?? "Something went wrong"
  //         );
  //       } else {
  //         setLoading(false);
  //         ErrorMessage("Something went wrong");
  //       }
  //     });
  // };

  // const deleteClientPopUp = {
  //   visibility: isDeleteModalOpen,
  //   content: (
  //     <ConfirmDelete
  //       title=""
  //       onClose={() => setIsDeleteModalOpen(false)}
  //       heading="Confirm deletion"
  //       paragraph={
  //         selectedRowKeys?.length > 0 ? (
  //           <>
  //             Are you sure you want to delete selected contract?
  //             <br />
  //             This action cannot be undone.
  //           </>
  //         ) : (
  //           <>
  //             Are you sure you want to delete <b>{tableRecord?.name}</b>?<br />
  //             <br />
  //             This action cannot be undone.
  //           </>
  //         )
  //       }
  //       btnText={
  //         selectedRowKeys?.length > 0
  //           ? `Delete ${
  //               selectedRowKeys?.length === 1
  //                 ? selectedRowKeys?.length + " contract"
  //                 : selectedRowKeys?.length + " contracts"
  //             }`
  //           : "Delete contract"
  //       }
  //       btnApi={deleteFunction}
  //       loading={loading}
  //     />
  //   ),
  //   width: 480,
  //   onCancel: () => setIsDeleteModalOpen(false),
  // };

  const terminateFunction = () => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      setIsTerminateModalOpen(false);
      SuccessMessage("Contract terminated");
    }, 1000);
  };

  const terminateClientPopUp = {
    visibility: isTerminateModalOpen,
    content: (
      <TerminatePopUp
        onClose={() => setIsTerminateModalOpen(false)}
        btnApi={terminateFunction}
        loading={loading}
      />
    ),
    width: 756,
    onCancel: () => setIsTerminateModalOpen(false),
  };

  const unWinFunction = () => {
    setLoading(true);

    contractUnwin(
      selectedRowKeys?.length > 0 ? selectedRowKeys : [tableRecord?.id]
    )
      .then(() => {
        setLoading(false);
        setIsUnWinModalOpen(false);
        fetchContractList();
        SuccessMessage("Contract reverted");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const unWinClientPopUp = {
    visibility: isUnWinModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsUnWinModalOpen(false)}
        heading="Confirm unwin action"
        isArchivePopup
        paragraph={
          <>
            This will remove the contract and revert it back to a potential
            deal. All tasks, checklist items, and documents added after it was
            won will be deleted.
            <br /> <br />
            Use this if the contract was sent to production by mistake.
          </>
        }
        btnText="Unwin contract"
        btnApi={unWinFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsUnWinModalOpen(false),
  };

  const taskDetailModal = {
    visibility: isTaskModalOpen,
    class: "Task_Modal",
    content: (
      <TaskModal
        onClose={() => setIsTaskModalOpen(false)}
        tableRecord={tableRecord}
        loading={loading}
      />
    ),
    width: 1200,
    onCancel: () => setIsTaskModalOpen(false),
  };

  const archiveFunction = () => {
    setLoading(true);
  };

  const confirmArchivedPopUp = {
    visibility: archivePopUp,
    content: (
      <ConfirmDelete
        title=""
        isArchivePopup={true}
        onClose={() => setArchivePopUp(false)}
        heading={tableRecord?.status === "active" ? "Archive" : "Activate"}
        paragraph={
          <>
            Are you sure you want to{" "}
            {/* {tableRecord?.status === "active" ? "archive" : "activate"}{" "}
            <b>{tableRecord?.name}</b>? <br /> <br />
            {tableRecord?.status === "active" && (
              <>This task won’t be available for use.</>
            )} */}
          </>
        }
        btnText={`${
          "Activate"
          // tableRecord?.status === "active" ? "Archive" : "Activate"
        } task`}
        btnApi={archiveFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setArchivePopUp(false),
  };

  const onClickRow = (record: any) => {
    return {
      onClick: () => {
        navigate(`/contracts/profile/${record.id}/${companyId}`);
      },
    };
  };

  useEffect(() => {
    dispatch(removeContractListData());
  }, [dispatch]);

  useEffect(() => {
    if (companyId) {
      const payload = {
        status: filters?.status ?? ["active"],
        offset: pagination > 1 ? limit * (pagination - 1) : pagination - 1,
        limit: limit,
        company_id: companyId,
        type: filters?.type ?? undefined,
        search_text: filters?.search_text ?? undefined,
      };
      dispatch(removeContractListData());
      dispatch(getContractListing(payload));
    }
  }, [dispatch, filters, pagination, limit, companyId]);

  return (
    <DashboardTemplate loading={contractListData?.loader || loading}>
      <Header
        title="Contracts list"
        description="View and manage company’s contracts."
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
      />
      <TableUi
        columns={columns}
        data={{
          count: contractListData?.count || 0,
          data: contractListData?.data || [],
        }}
        filters={
          <Filters
            setFilters={setFilters}
            filters={filters}
            archived={archived}
            isArchived={isArchived}
            companyId={companyId}
          />
        }
        pageSize={limit}
        setPageSize={setLimit}
        setCurrentPage={setPagination}
        currentPage={pagination}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        onClickRow={onClickRow}
      />
      {contractListData?.count === 0 && (
        <div className="empty_wrap">
          <EmptyCard
            imageHeight={220}
            title={
              archived
                ? "There are no completed contracts"
                : filters?.search_text
                ? "No results match the filter or search criteria"
                : `There are no ${filters?.status ?? "active"} contracts`
            }
            description={
              archived
                ? "We believe in our absolute success and hope to never have an completed contracts here."
                : filters?.search_text
                ? "Try adjusting the filters and search."
                : "Win your first contract and it’ll appear here."
            }
            image={
              archived
                ? "/images/empty-icons/no-archived.svg"
                : "/images/empty-icons/no-active.svg"
            }
          />
        </div>
      )}

      {selectedRowKeys?.length !== 0 ? (
        <div className="selection_bar">
          <div className="selected_count">
            <Button
              icon={<CrossIcon style={{ color: "white" }} />}
              className="only_icon"
              type="text"
              onClick={() => setSelectedRowKeys([])}
            />
            {selectedRowKeys.length}{" "}
            {`${selectedRowKeys.length === 1 ? "contract" : "contracts"}`}{" "}
            selected
          </div>
          <div className="selection_buttons">
            <Button
              type="text"
              icon={<DeleteIcon />}
              onClick={() => {
                setIsUnWinModalOpen(true);
              }}
            >
              Unwin
            </Button>
          </div>
        </div>
      ) : null}

      <PopUp {...terminateClientPopUp} />
      <PopUp {...unWinClientPopUp} />
      {/* <PopUp {...deleteClientPopUp} /> */}
      <PopUp {...confirmArchivedPopUp} />
      <PopUp {...taskDetailModal} />
    </DashboardTemplate>
  );
}
